import services from 'api/services';
import { logError } from 'global/errors';

import {
  LOAD_TICKETS_REQUEST,
  LOAD_TICKETS_SUCCESS,
  LOAD_TICKETS_FAILURE,
  UPDATE_ADMIN_DEPARTMENT_REQUEST,
  UPDATE_ADMIN_DEPARTMENT_SUCCESS,
  UPDATE_ADMIN_DEPARTMENT_FAILURE,
  UPDATE_VIEW_ALL_DEPARTMENTS_REQUEST,
  UPDATE_VIEW_ALL_DEPARTMENTS_SUCCESS,
  UPDATE_VIEW_ALL_DEPARTMENTS_FAILURE,
  ARCHIVE_TICKET_REQUEST,
  ARCHIVE_TICKET_SUCCESS,
  ARCHIVE_TICKET_FAILURE,
  UPDATE_VIEW_ALL_COMPANIES_REQUEST,
  UPDATE_VIEW_ALL_COMPANIES_SUCCESS,
  UPDATE_VIEW_ALL_COMPANIES_FAILURE,
  UPDATE_ADMIN_COMPANY_REQUEST,
  UPDATE_ADMIN_COMPANY_SUCCESS,
  UPDATE_ADMIN_COMPANY_FAILURE,
  RESET_UPDATED_IDS,
} from './constants';
import { AUTH_UPDATE_SUCCESS } from 'global/constants';

const { TicketService, AccountService } = services;

export const loadTickets = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_TICKETS_REQUEST });
    const response = await TicketService.loadCompanyTickets();
    dispatch({ type: LOAD_TICKETS_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_TICKETS_FAILURE, error: ex.message });
  }
};

export const updateAdminDepartment = (departmentId) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ADMIN_DEPARTMENT_REQUEST });
    const response = await AccountService.updateAdminDepartment(departmentId);
    dispatch({ type: AUTH_UPDATE_SUCCESS, data: { adminDepartment: response.adminDepartment } });
    dispatch({ type: UPDATE_ADMIN_DEPARTMENT_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_ADMIN_DEPARTMENT_FAILURE, error: ex.message });
  }
};

export const updateViewAllDepartments = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_VIEW_ALL_DEPARTMENTS_REQUEST });
    const response = await AccountService.updateViewAllDepartments(body);
    dispatch({ type: AUTH_UPDATE_SUCCESS, data: { viewAllDepartments: response.viewAllDepartments } });
    dispatch({ type: UPDATE_VIEW_ALL_DEPARTMENTS_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_VIEW_ALL_DEPARTMENTS_FAILURE, error: ex.message });
  }
};

export const archiveTicket = (ticketId) => async (dispatch) => {
  try {
    dispatch({ type: ARCHIVE_TICKET_REQUEST });
    const response = await TicketService.archiveTicket(ticketId);
    dispatch({ type: ARCHIVE_TICKET_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: ARCHIVE_TICKET_FAILURE, error: ex.message });
  }
};

export const updateViewAllCompanies = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_VIEW_ALL_COMPANIES_REQUEST });
    const response = await AccountService.updateViewAllCompanies(body);
    dispatch({
      type: AUTH_UPDATE_SUCCESS,
      data: { viewAll: response.viewAll },
    });
    dispatch({ type: UPDATE_VIEW_ALL_COMPANIES_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_VIEW_ALL_COMPANIES_FAILURE, error: ex.message });
  }
};

export const updateAdminCompany = (companyId) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ADMIN_COMPANY_REQUEST });
    const response = await AccountService.updateAdminCompany(companyId);
    dispatch({
      type: AUTH_UPDATE_SUCCESS,
      data: { adminCompany: response.adminCompany, adminDepartment: response.adminDepartment },
    });
    dispatch({ type: UPDATE_ADMIN_COMPANY_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_ADMIN_COMPANY_FAILURE, error: ex.message });
  }
};

export const resetUpdatedIds = () => async (dispatch) => {
  dispatch({ type: RESET_UPDATED_IDS });
};
